import React, {Component} from "react";
import styles from "./services.module.scss";
import appweb from '../HomeSlider/img/blanccambouis-web.png';
import portail from '../HomeSlider/img/ccilyon-web.png';
import ecommerce from '../HomeSlider/img/emmaus-web.jpg';
import site from '../HomeSlider/img/handiscover-web.jpg';
import iot from '../HomeSlider/img/ipaje-web.jpg';
import myooh from "../HomeSlider/img/digital-signage.jpg";
import scoreit from "../HomeSlider/img/scoreit-network.png";
import symfony from "./img/developpeur-symfony.png";
import mobile from "./img/developpeur-mobile.jpg";
import webdesign from "./img/webdesign.jpg";

class Offre extends Component {
    discover(data, title) {
        if(data != "") {
            return  <div className="col-md-12 p-0 d-flex justify-content-md-start justify-content-center">
                    <a  href={data} target="_blank" title={'En savoir plus sur  les '+title} className="btn btn-primary">Découvrir l'offre d'emploi</a>
                </div>;
        }
    }
    render() {
        let services = [
            {
                title: 'Développeur Symfony / PHP (H/F)',
                subtitle: 'Rejoignez notre équipe de développpement !',
                image: symfony,
                description: ["Envie de relever de nouveaux challenges ? Travailler sur des projets et des technologies innovantes ? N'hésitez pas à découvrir notre offre de ", <strong>développeur Symfony</strong>, " PHP"],
                url: '/developpeur-symfony-offre-emploi'
            },
            {
                title: 'Développeur Mobile Hybride',
                subtitle: 'React native',
                image: mobile,
                description: ["Dans le cadre de sa croissance, Integral Service recherche des profils pour rejoindre son équipe de développement mobile."],
                url: '/developpeur-mobile-offre-emploi'
            },
            {
                title: 'Stage Web designer',
                subtitle: 'UI/UX',
                image: webdesign,
                description: ["Nous recherchons un ou une stagiaire en Web design UI/UX. Des compétences en mobile design ?"],
                url: '/web-designer-offre-emploi'
            }

        ];
        let servicesHmtlList = (
            <div>
                {services.map((service,index) =>
                    <section className={styles.serviceSection}>
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-12">
                                    <div className={`row row-bottom-padded-md row-top-padded-md ${styles.serviceContent} ${(index%2?'flex-row-reverse':'flex-row')}`}>
                                        <div className='col-md-7 align-self-stretch d-flex text-center'>
                                        <img src={service.image} alt={service.title} className={`text-sm-center img-fluid align-self-center`}/>
                                        </div>
                                        <div className="col-md-5 align-self-stretch d-flex">
                                            <div className="align-self-center">
                                                <h2 className="text-center text-md-left p-0 col-12 mb-2">{service.title}</h2>
                                                <h3 className="text-center text-md-left p-0 col-12">{service.subtitle}</h3>
                                                <p className="text-justify">
                                                {service.description}
                                                </p>
                                                { this.discover(service.url, service.title) }
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </section>
                )}
            </div>

        );

        return (
            <div className="serviceList">
                {servicesHmtlList}
            </div>
        );
    }
}

export default Offre;



// WEBPACK FOOTER //
// ./src/components/Page/Offre.jsx